import {Select} from 'antd';
import PropTypes from 'prop-types';
import React from 'react';
import {useTranslation} from 'react-i18next';
import {EmpresaConta} from '../../constants';

const {Status} = EmpresaConta;

export default function SelectEmpresaContaStatus(props) {
  const {t} = useTranslation();

  const createOption = ({id, label}) => (
      <Select.Option value={id}>
        {t(label)}
      </Select.Option>);

  return (
      <Select {...props} >
        {createOption(Status.Pendente)}
        {createOption(Status.Publicada)}
        {createOption(Status.Aprovada)}
        {createOption(Status.Registrada)}
      </Select>
  );
}

SelectEmpresaContaStatus.propTypes = {
  value: PropTypes.oneOf([
    Status.Pendente.id,
    Status.Publicada.id,
    Status.Aprovada.id,
    Status.Registrada.id]),
  onChange: PropTypes.func,
};
